import { useCallback } from 'react'

import { CustomPreferencesArmMapping, ExperimentPayload } from '../types'
import { generateCustomPreferencesExperimentPayload } from '../utils'

export const useSendCustomPreferencesExperimentData = ({
  deviceUUID,
  lyraId,
  postExperimentEntrypoint,
  userInExperiment,
  isCustomPreferencesEnabled,
}: {
  deviceUUID: string
  lyraId: string
  postExperimentEntrypoint: (payload: ExperimentPayload) => void
  userInExperiment: boolean
  isCustomPreferencesEnabled?: boolean
}) => {
  return useCallback(() => {
    if (!userInExperiment) return
    const arm = isCustomPreferencesEnabled
      ? CustomPreferencesArmMapping.EXPERIMENT
      : CustomPreferencesArmMapping.CONTROL
    const customPreferencesExperimentPayload = generateCustomPreferencesExperimentPayload({
      arm,
      client_lyra_id: lyraId,
      device_uuid: deviceUUID,
    })
    postExperimentEntrypoint(customPreferencesExperimentPayload)
  }, [deviceUUID, lyraId, postExperimentEntrypoint, userInExperiment, isCustomPreferencesEnabled])
}
